import React from "react";
import { Card } from "../card";
import { useGetMembersOverview } from "../../hooks/membersOverView/membersOverView.hooks";
import { FontSize } from "../../Constants/Enums/Size.enums";
import { Colors } from "../../Constants/colors";
import StudentsIcon from "./../../images/students-dashboard.svg";
import TeachersIcon from "./../../images/teacher-dashboard-com.svg";
import ParentsIcon from "./../../images/parents-dashboard.svg";

export const TotalMembersOverview = () => {
  const { isLoading: isMembersOverViewLoading, data: membersOverView } =
    useGetMembersOverview();

  if (isMembersOverViewLoading) return <></>;

  const transformedData = [
    {
      image: StudentsIcon,
      title: "Students",
      value: membersOverView?.totalStudentsCount,
      color: "#3cb878",
    },
    {
      image: TeachersIcon,
      title: "Teacher",
      value: membersOverView?.totalTeachersCount,
      color: "#3f7afc",
    },
    {
      image: ParentsIcon,
      title: "Parents",
      value: membersOverView?.totalParentsCount,
      color: "#ffa001",
    },

    // May be we can add this letter.
    // {
    //   image: 'test',
    //   title: 'Staff',
    //   value: membersOverView?.otherStaffCount,
    // },
  ];
  return (
    <div className="flex grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 justify-around gap-8">
      {transformedData.map(({ image, title, value, color }) => {
        return (
          <Card>
            <div className="flex gap-6">
              <div
                style={{
                  width: "100px",
                  height: "100px",
                  borderRadius: "50%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <img
                  src={image}
                  alt="students-icon"
                  style={{
                    width: "50px",
                    height: "50px",
                    color: color,
                    position: "absolute",
                  }}
                />
                <div
                  style={{
                    backgroundColor: color,
                    width: "100%",
                    height: "100%",
                    opacity: 0.1,
                    position: "absolute",
                  }}
                />
              </div>
              <div className="flex flex-col text-right">
                <p
                  className="Sub-Header"
                  style={{
                    color: Colors.DarkGrey,
                  }}
                >
                  {title}
                </p>
                <p
                  style={{
                    fontSize: FontSize.F28,
                    color: Colors.Black,
                  }}
                >
                  {value}
                </p>
              </div>
            </div>
          </Card>
        );
      })}
    </div>
  );
};
